import { apiSlice, createPaginatedListEndpoint, createBodyMutation } from './baseApi';

export const serviceCompanyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getServiceCompanies: builder.query({
      query: (companyId) => ({
        url: '/service-company/get-all-service-companies',
        method: 'POST',
        body: { company_id: companyId },
      }),
      transformResponse: (response) => response?.serviceCompanies ?? [],
      providesTags: ['ServiceCompanies'],
    }),
    getServiceCompaniesList: builder.query(
      createPaginatedListEndpoint({
        url: '/service-company/get-all-service-companies',
        responseKey: 'serviceCompanies',
        tag: 'ServiceCompanies',
      })
    ),
    addServiceCompany: builder.mutation(
      createBodyMutation({ url: '/service-company/add-service-company', invalidatesTags: ['ServiceCompanies'] })
    ),
    editServiceCompany: builder.mutation(
      createBodyMutation({ url: '/service-company/edit-service-company', invalidatesTags: ['ServiceCompanies'] })
    ),
    deleteServiceCompany: builder.mutation(
      createBodyMutation({ url: '/service-company/delete-service-company', invalidatesTags: ['ServiceCompanies'] })
    ),
  }),
});
